import React, { Suspense } from "react";

import { CircularProgressCenter } from "igfd-ui/src/app-index";

/**
 * Fall back to a loading indicator.
 * @param Component
 * @returns
 */
export const WithFallback = (
  Component: React.ComponentType<any>,
  fullScreen = true
) => (
  <WithFallbackComponent fullScreen={fullScreen}>
    <Component />
  </WithFallbackComponent>
);

const WithFallbackComponent = ({
  children,
  fullScreen = true,
}: {
  children: React.ReactNode;
  fullScreen?: boolean;
}) => (
  <Suspense fallback={<CircularProgressCenter fullScreen={fullScreen} />}>
    {children}
  </Suspense>
);
